import { Component, Shark, Utils } from "shark-mvc";
import contentsManager from "../../controllers/contentsManager";
import ImageContent from "../../models/ImageContent";
import PlaceContent from "../../models/PlaceContent";
import TextContent from "../../models/TextContent";

import templateContent from "./content-finder.html";
import "./style.css";

class ContentFinderComponent extends Component {
	constructor () {
		super("contentFinderComponent");

		this.addTemplate("", templateContent);
	}

	foundContentBtn_clickHandler (event, data) {
		switch (data.contentType) {
			case "image":
				data.title = Utils.safp(Shark.$store.searchResultImageContentList, "guid", data.guid).title;
				break;
			case "place":
				data.title = Utils.safp(Shark.$store.searchResultPlaceContentList, "guid", data.guid).title;
				break;
			case "text":
				data.title = Utils.safp(Shark.$store.searchResultTextContentList, "guid", data.guid).title;
				break;
		}

		console.log("ContentFinderComponent content_selected dispatched");
		this.emit("content_selected", data);
	}

	getContents () {
		const { contentFinderFilters } = Shark.get();

		contentsManager.search(contentFinderFilters.export())
		.then(searchResponse => {
			let searchResultImageContentList = Shark.getInstanceList(ImageContent, searchResponse?.data?.images);
			let searchResultPlaceContentList = Shark.getInstanceList(PlaceContent, searchResponse?.data?.places);
			let searchResultTextContentList = Shark.getInstanceList(TextContent, searchResponse?.data?.texts);

			if (Shark.$store.currContent) {
				searchResultImageContentList = searchResultImageContentList.filter(item => item.guid !== Shark.$store.currContent.guid);
				searchResultPlaceContentList = searchResultPlaceContentList.filter(item => item.guid !== Shark.$store.currContent.guid);
				searchResultTextContentList = searchResultTextContentList.filter(item => item.guid !== Shark.$store.currContent.guid);
			}
				
			Shark.set({
				searchResultImageContentList,
				searchResultPlaceContentList,
				searchResultTextContentList,
				__showContentFinderSearchResultClass: (contentFinderFilters.__searchTypeTagEnabled || contentFinderFilters.__searchTypeTextEnabled || contentFinderFilters.__textEnabled) ? " show" : "",
			});
			// Shark.render();
		});
	}

	init () {
		const contentFinderFilters = Shark.getInstance("__smart__", {
			advancedSearch: ["tagInternal", "tagReferenceVolumes", "textsTitle", "textsSubtitle", "textsAbstract", "textsDescription", "textsImageAuthor", "textsImageFileName", "textsImageSource", "textsImageDates"],
			contentType: ["image", "place", "text"],
			searchType: ["texts", "tags"],
			searchKey: "",


			__imageEnabled: true,
			__placeEnabled: true,
			__searchTypeTagEnabled: true,
			__searchTypeTextEnabled: true,
			__textEnabled: true,
		});

		contentFinderFilters.onDataChanged = () => {
			console.log("contentFinderFilters.onDataChanged", Shark.$store.contentFinderFilters);

			Shark.$store.contentFinderFilters.__imageEnabled = Shark.$store.contentFinderFilters.contentType.includes("image");
			Shark.$store.contentFinderFilters.__placeEnabled = Shark.$store.contentFinderFilters.contentType.includes("place");
			Shark.$store.contentFinderFilters.__textEnabled = Shark.$store.contentFinderFilters.contentType.includes("text");

			Shark.$store.contentFinderFilters.__searchTypeTagEnabled = Shark.$store.contentFinderFilters.searchType.includes("tags");
			Shark.$store.contentFinderFilters.__searchTypeTextEnabled = Shark.$store.contentFinderFilters.searchType.includes("texts");

			if (Shark.$store.contentFinderFilters.searchKey.length > 2) {
				this.getContents();
			}
			else {
				Shark.set({
					searchResultImageContentList: [],
					searchResultPlaceContentList: [],
					searchResultTextContentList: [],
					__showContentFinderSearchResultClass: "",
				});
				// Shark.render();
			}
		};

		Shark.set({
			contentFinderFilters,
			searchResultImageContentList: [],
			searchResultPlaceContentList: [],
			searchResultTextContentList: [],
		});
	}

	// userInputModalCancelBtn_clickHandler () {
	// 	const requestSettings = this.get("requestSettings");

	// 	if (requestSettings.cancelHandler) {
	// 		requestSettings.cancelHandler();
	// 	}

	// 	this.close();
	// }

	// userInputModalConfirmBtn_clickHandler () {
	// 	const userInputModalContent = Shark.get("userInputModalContent");

	// 	if (this.validateUserContent()) {
	// 		const requestSettings = this.get("requestSettings");
			
	// 		if (requestSettings.confirmHandler) {
	// 			requestSettings.confirmHandler()
	// 			.then(() => {
	// 				this.close();
	// 			});
	// 		}
	// 		else {
	// 			this.close();
	// 		}
	// 	}
	// }

	resetContentFinderSearchField () {
		Shark.$store.contentFinderFilters.set({searchKey: ""});
	}

	resetContentFinderSearchFieldBtn_clickHandler () {
		this.resetContentFinderSearchField();
	}
}

const contentFinderComponent = new ContentFinderComponent();

Shark.registerComponent(contentFinderComponent);

export default contentFinderComponent;
